import { useState } from 'react'

import history from '@/services/history'

import useService from '@/main/hooks/useService'

export const useSendFile = ({ brokerData }) => {
  const [response, setResponse] = useState(null)

  const goToNextStep = (orderId) => {
    history.push({
      pathname: '/recargas/pedido_recarga_broker/dados',
      state: { orderId },
    })
  }

  const [sendFileState, sendFileRequest] = useService(brokerData?.uploadOrderFile, {
    onCompleted: (res) => {
      if (res.data.base64) {
        setResponse(res.data)
        return
      }
      goToNextStep(res.data.id)
    },
  })

  return {
    sendFileState,
    sendFileRequest,
    response,
    setResponse,
  }
}
